import {SET_PLUGIN_TO_SAVE} from 'constants/action-types.js';
import {SET_SHOW_PLUGINS} from 'constants/action-types.js';
import {SET_PLUGINS_LOADED} from 'constants/action-types.js';
import {SET_SHOW_PLUGINS_PANE} from 'constants/action-types.js';
import {SET_PLUGINS_PANE_HEIGHT} from 'constants/action-types.js';

export default (state = {showPluginsPane: true}, action) => {
    switch (action.type) {
    case SET_PLUGINS_PANE_HEIGHT:
        return {
            ... state,
            pluginsPaneHeight: action.payload
        };
    case SET_SHOW_PLUGINS_PANE:
        return {
            ... state,
            showPluginsPane: action.payload
        };
    case SET_SHOW_PLUGINS:
        return {
            ... state,
            showPlugins: action.payload
        };
    case SET_PLUGINS_LOADED:
        return {
            ... state,
            pluginsLoaded: action.payload
        };
    case SET_PLUGIN_TO_SAVE:
        return {
            ... state,
            pluginToSave: action.payload
        };
    default:
        return state;
    }
}
